import {
    ArrayModel,
    assignModelOptions,
    CompositeModel,
    ConfigConstants,
    ConfigService,
    CustomInjector,
    MaterialModel,
    ModelOptionsLoaderService,
    NotificationModel,
    TextModel,
} from '@evorait/pace-core';

export default class ConfirmationMaterialStockModel extends CompositeModel {
    public materialNumber: TextModel;
    public materialDesc: TextModel;
    public storageLocation: TextModel;
    public materials: TextModel;
    public partSet: ArrayModel<MaterialModel>;
    public notification: NotificationModel | undefined;
    public frontId: string;
    public showNoStockAvailable: boolean;
    public constructor(
        public consumptionList: ArrayModel<MaterialModel>,
        notificationModel: NotificationModel | undefined,
        screenName: string,
        public cseMaterialStocks: MaterialModel[] = [],
    ) {
        super('ConfirmationMaterialStockModel');

        const injector = CustomInjector.getInjector();
        const modelOptionsLoader = injector.get(ModelOptionsLoaderService);
        const configService = injector.get(ConfigService);

        this.notification = notificationModel;
        this.materialNumber = new TextModel('MaterialNumber');
        modelOptionsLoader.load(this.materialNumber, screenName, 'MaterialNumber');
        this.materialNumber = assignModelOptions(
            this.materialNumber,
            {
                ...this.materialNumber.options,
                applicationIdentifier: ConfigConstants.ApplicationIdentifier.ProductIdentifier,
            },
            this,
        );
        this.materialDesc = new TextModel('MaterialDesc');
        this.storageLocation = new TextModel('StorageLocation');
        if (screenName === ConfigConstants.OTHER_STOCK_SCREEN) {
            modelOptionsLoader.load(this.storageLocation, 'CseOtherStock', 'StorageLocation');
        }
        this.frontId = configService.getUserFrontId();
        if (cseMaterialStocks && cseMaterialStocks.length === 0) {
            this.showNoStockAvailable = true;
        }
    }
}
